import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-borrower-request-page',
    templateUrl: './borrower-request-page.component.html',
    styleUrl: './borrower-request-page.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BorrowerRequestPageComponent {

}
